import React from 'react'

const MarkDown = ({ children, className }) => {
  if (!children) return null

  let content = children
  const links = children.match(/\[.*?\)/g)

  if (links && links.length > 0) {
    links.forEach((link) => {
      const txt = link.match(/\[(.*?)\]/)[1]
      const url = link.match(/\((.*?)\)/)[1]
      content = content.replace(link, `<a href="${url}" target="_blank">${txt}</a>`)
    })
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
}

export default MarkDown
